import React, { useEffect, useState } from 'react';
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonFooter,
    IonLabel,
    IonTextarea,
    IonIcon,
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

interface TransactionReasonModalProps {
    isOpen: boolean;
    title: string;
    onConfirm: (reason: string) => void;
    onCancel: () => void;
}

const TransactionReasonModal: React.FC<TransactionReasonModalProps> = ({
    isOpen,
    title,
    onConfirm,
    onCancel,
}) => {
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (isOpen) {
            setReason('');
        }
    }, [isOpen]);

    const handleConfirm = () => {
        if (reason.trim()) {
            onConfirm(reason.trim());
        }
    };

    return (
        <IonModal isOpen={isOpen} onDidDismiss={onCancel} style={{ '--width': '400px', '--height': '300px', '--border-radius': '8px' }}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle style={{ fontSize: '1rem' }}>{title}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={onCancel}>
                            <IonIcon icon={closeOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent style={{ '--padding-start': '1rem', '--padding-end': '1rem', '--padding-top': '1rem', '--padding-bottom': '1rem' }}>
                <div style={{ padding: '1rem 0' }}>
                    <IonLabel style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                        Reason <span style={{ color: 'var(--ion-color-danger)' }}>*</span>
                    </IonLabel>
                    <IonTextarea
                        value={reason}
                        onIonInput={(e) => setReason(e.detail.value ?? '')}
                        placeholder="Enter reason for this change..."
                        rows={4}
                        style={{ border: '1px solid var(--ion-color-medium)', borderRadius: '4px', padding: '0.5rem' }}
                        autoFocus
                    />
                </div>
            </IonContent>

            <IonFooter>
                <IonToolbar style={{ '--padding-start': '1rem', '--padding-end': '1rem' }}>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={onCancel}>Cancel</IonButton>
                    </IonButtons>
                    <IonButtons slot="end">
                        <IonButton
                            color="primary"
                            fill="solid"
                            disabled={!reason.trim()}
                            onClick={handleConfirm}
                        >
                            Confirm
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
};

export default TransactionReasonModal;
